import { useState, useCallback } from "react";

const ruToEn = {
  "вилла": "villa", "виллу": "villa", "виллы": "villa",
  "квартира": "apartment", "квартиру": "apartment", "квартиры": "apartment",
  "офис": "office", "дубай": "Dubai",
  "море": "sea", "морем": "sea", "морской": "sea",
  "вид": "view", "видом": "view",
  "бассейн": "pool", "терраса": "terrace", "террасой": "terrace",
  "интерьер": "interior", "экстерьер": "exterior",
  "современный": "modern", "современная": "modern",
  "классический": "classic", "роскошный": "luxury", "роскошная": "luxury",
  "пентхаус": "penthouse", "студия": "studio", "дом": "house",
  "закат": "sunset", "рассвет": "sunrise",
  "ночной": "night", "дневной": "day",
  "городской": "city", "пляж": "beach", "горы": "mountains",
  "белый": "white", "белая": "white",
  "чёрный": "black", "черный": "black",
  "серый": "grey", "золотой": "golden",
  "бурдж": "Burj", "бурж": "Burj", "аль": "Al",
  "пальма": "Palm", "джумейра": "Jumeirah",
  "небоскрёб": "skyscraper", "небоскреб": "skyscraper",
  "панорамный": "panoramic", "панорамная": "panoramic",
  "минималистичный": "minimalist",
  "мрамор": "marble", "мраморный": "marble",
  "стеклянный": "glass", "с видом на": "with view of",
};

const translate = (text) => {
  if (!text) return "";
  let result = text;
  Object.entries(ruToEn).forEach(([ru, en]) => {
    result = result.replace(new RegExp(`\\b${ru}\\b`, "gi"), en);
  });
  return result;
};

const CATEGORIES = {
  subject: {
    label: "Субъект / Объект",
    labelEn: "",
    icon: "🎯",
    placeholder: "Опишите главный объект: вилла в Dubai, современный офис с видом на море...",
    type: "text",
  },
  style: {
    label: "Стиль",
    labelEn: "Style",
    icon: "🎨",
    options: [
      ["Фотореализм", "Photorealistic"],
      ["Гиперреализм", "Hyperrealistic"],
      ["Кинематограф", "Cinematic"],
      ["Редакционное фото", "Editorial photography"],
      ["Архитектурная визуализация", "Architectural visualization"],
      ["Дизайн интерьера", "Interior design render"],
      ["Масло", "Oil Painting"],
      ["Акварель", "Watercolor"],
      ["Цифровое искусство", "Digital Art"],
      ["Аниме / Манга", "Anime / Manga"],
      ["3D рендер", "3D Render"],
      ["Пиксель арт", "Pixel Art"],
      ["Карандашный эскиз", "Pencil Sketch"],
      ["Уголь", "Charcoal Drawing"],
      ["Поп-арт", "Pop Art"],
      ["Ар-нуво", "Art Nouveau"],
      ["Сюрреализм", "Surrealism"],
      ["Импрессионизм", "Impressionism"],
      ["Минимализм", "Minimalism"],
      ["Киберпанк", "Cyberpunk"],
      ["Фэнтези", "Fantasy Art"],
      ["Готика", "Gothic"],
      ["Ретро / Винтаж", "Retro / Vintage"],
      ["Концепт-арт", "Concept Art"],
      ["Ар-деко", "Art Deco"],
      ["Брутализм", "Brutalism"],
      ["Скандинавский", "Scandinavian"],
    ],
  },
  camera: {
    label: "Ракурс / Камера",
    labelEn: "Angle / Camera",
    icon: "📷",
    options: [
      ["Крупный план", "Close-up"],
      ["Экстремальный крупный план", "Extreme close-up"],
      ["Средний план", "Medium shot"],
      ["В полный рост", "Full body shot"],
      ["Широкий угол", "Wide angle"],
      ["Ультра широкий", "Ultra wide angle"],
      ["Вид сверху", "Bird's eye view"],
      ["Вид снизу", "Worm's eye view"],
      ["Голландский угол", "Dutch angle"],
      ["Из-за плеча", "Over the shoulder"],
      ["От первого лица", "POV (first person)"],
      ["Аэросъёмка", "Aerial view"],
      ["Изометрический", "Isometric view"],
      ["Профиль", "Side profile"],
      ["Три четверти", "Three-quarter view"],
      ["Фронтальный", "Frontal view"],
      ["Низкий угол", "Low angle"],
      ["Высокий угол", "High angle"],
      ["Макро", "Macro shot"],
      ["Телефото / Боке", "Telephoto / Bokeh"],
      ["Рыбий глаз", "Fish-eye lens"],
      ["Тилт-шифт", "Tilt-shift"],
      ["Дрон", "Drone shot"],
      ["Объектив 35мм", "35mm lens"],
      ["Объектив 50мм", "50mm lens"],
      ["Портретный 85мм", "85mm portrait lens"],
      ["Широкий 24мм", "24mm wide lens"],
    ],
  },
  lighting: {
    label: "Освещение",
    labelEn: "Lighting",
    icon: "💡",
    options: [
      ["Естественный свет", "Natural light"],
      ["Золотой час", "Golden hour"],
      ["Синий час", "Blue hour"],
      ["Магический час", "Magic hour"],
      ["Драматическое", "Dramatic lighting"],
      ["Контровой свет", "Rim lighting"],
      ["Контражур", "Backlighting"],
      ["Мягкий рассеянный", "Soft diffused light"],
      ["Жёсткий свет", "Hard light"],
      ["Неоновое свечение", "Neon glow"],
      ["Объёмный свет", "Volumetric light"],
      ["Кьяроскуро", "Chiaroscuro"],
      ["Студийное", "Studio lighting"],
      ["Рембрандт", "Rembrandt lighting"],
      ["Раздельное", "Split lighting"],
      ["Свечи", "Candlelight"],
      ["Лунный свет", "Moonlight"],
      ["Пасмурно", "Overcast"],
      ["Прожектор", "Spotlight"],
      ["Рассвет", "Sunrise"],
      ["Закат", "Sunset"],
      ["Полдень", "Midday sun"],
      ["Тёплый свет", "Warm tungsten light"],
      ["Холодный свет", "Cool fluorescent"],
      ["Высокий ключ", "High-key lighting"],
      ["Низкий ключ", "Low-key lighting"],
    ],
  },
  color: {
    label: "Цветовая палитра",
    labelEn: "Color Palette",
    icon: "🌈",
    options: [
      ["Яркие / Насыщенные", "Vibrant / Saturated"],
      ["Приглушённые", "Muted / Desaturated"],
      ["Монохром", "Monochrome"],
      ["Тёплые тона", "Warm tones"],
      ["Холодные тона", "Cool tones"],
      ["Пастель", "Pastel"],
      ["Земляные тона", "Earth tones"],
      ["Неон", "Neon"],
      ["Чёрно-белый", "Black & White"],
      ["Сепия", "Sepia"],
      ["Высокий контраст", "High contrast"],
      ["Тёмная палитра", "Dark moody palette"],
      ["Светлая палитра", "Light airy palette"],
      ["Дуотон", "Duotone"],
      ["Золото и кремовый", "Golden & cream"],
      ["Тёмно-синий и золотой", "Navy & gold"],
      ["Шалфей и терракота", "Sage & terracotta"],
      ["Полночный синий и серебро", "Midnight blue & silver"],
      ["Розовое золото и белый", "Rose gold & white"],
      ["Изумруд и бронза", "Emerald & bronze"],
      ["Слоновая кость и уголь", "Ivory & charcoal"],
      ["Коралловый и бирюза", "Coral & teal"],
    ],
  },
  composition: {
    label: "Композиция",
    labelEn: "Composition",
    icon: "📐",
    options: [
      ["Правило третей", "Rule of thirds"],
      ["По центру / Симметрия", "Centered / Symmetry"],
      ["Золотое сечение", "Golden ratio"],
      ["Направляющие линии", "Leading lines"],
      ["Кадр в кадре", "Frame within frame"],
      ["Негативное пространство", "Negative space"],
      ["Малая глубина резкости", "Depth of field (shallow)"],
      ["Большая глубина резкости", "Depth of field (deep)"],
      ["Передний план", "Foreground interest"],
      ["Многоуровневая глубина", "Layered depth"],
      ["Диагональная", "Diagonal composition"],
      ["Панорамная", "Panoramic"],
    ],
  },
  mood: {
    label: "Настроение / Атмосфера",
    labelEn: "Mood",
    icon: "✨",
    options: [
      ["Спокойное / Умиротворённое", "Serene / Peaceful"],
      ["Эпичное / Величественное", "Epic / Grand"],
      ["Таинственное", "Mysterious / Enigmatic"],
      ["Тёмное / Зловещее", "Dark / Ominous"],
      ["Радостное", "Joyful / Uplifting"],
      ["Меланхоличное", "Melancholic / Nostalgic"],
      ["Романтическое", "Romantic / Dreamy"],
      ["Интенсивное / Драматичное", "Intense / Dramatic"],
      ["Эфирное", "Ethereal / Otherworldly"],
      ["Уютное / Интимное", "Cozy / Intimate"],
      ["Футуристическое", "Futuristic / Sci-fi"],
      ["Игривое", "Whimsical / Playful"],
      ["Элегантное / Роскошное", "Elegant / Luxurious"],
      ["Суровое", "Raw / Gritty"],
      ["Пышное / Экстравагантное", "Opulent / Extravagant"],
      ["Минималистичное / Дзен", "Minimalist / Zen"],
      ["Авантюрное", "Adventurous / Wild"],
      ["Сюрреалистичное", "Surreal / Dreamlike"],
      ["Профессиональное", "Corporate / Professional"],
      ["Богемное / Артистичное", "Bohemian / Artistic"],
      ["Индустриальное / Городское", "Industrial / Urban"],
    ],
  },
  detail: {
    label: "Качество / Детализация",
    labelEn: "Quality",
    icon: "🔍",
    options: [
      ["Ультра детализированный", "Ultra detailed"],
      ["8K разрешение", "8K resolution"],
      ["Высокая детализация", "Highly detailed"],
      ["Тонкие детали", "Intricate details"],
      ["Чёткий фокус", "Sharp focus"],
      ["Мягкий фокус", "Soft focus"],
      ["Гиперреализм", "Hyperrealistic"],
      ["HDR", "HDR"],
      ["Трассировка лучей", "Ray tracing"],
      ["Глобальное освещение", "Global illumination"],
      ["Зернистость плёнки", "Film grain"],
      ["Плавный рендер", "Smooth rendering"],
    ],
  },
  negative: {
    label: "Исключить (негативный промт)",
    labelEn: "Negative Prompt",
    icon: "🚫",
    placeholder: "blurry, low quality, watermark, text, deformed, ugly, duplicate, extra limbs...",
    type: "text",
  },
  aspect: {
    label: "Соотношение сторон",
    labelEn: "Aspect Ratio",
    icon: "🖼️",
    options: [
      ["1:1 — Квадрат", "1:1"],
      ["16:9 — Горизонталь", "16:9"],
      ["9:16 — Вертикаль", "9:16"],
      ["4:3", "4:3"],
      ["3:4", "3:4"],
      ["21:9 — Ультраширокий", "21:9"],
      ["2:3", "2:3"],
      ["3:2", "3:2"],
    ],
  },
};

const ORDER = ["subject", "style", "camera", "lighting", "color", "composition", "mood", "detail", "negative", "aspect"];

const LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 221.66"><path d="M84.40097,75.33598l-16.17213-4.71202c-12.28677-4.16318-28.71067-6.94353-28.91384-20.30857,.13613-14.97876,16.22965-19.80889,29.52661-19.70205,16.92324-.15291,35.47947,5.70194,48.64459,15.44218l15.43153-25.52697C117.02392,5.92223,91.80919-.00582,68.84166,.39635,38.08853-.44627,4.07899,18.53629,4.52097,52.00658c.84164,28.52066,19.60109,40.5902,48.63765,48.95535,10.62613,2.88756,33.04852,8.59636,38.46985,13.96234,9.1042,7.05337,7.94297,21.41289-2.5724,26.6501-5.80095,3.22443-13.2875,3.59257-22.59807,3.59257-12.14045,.34479-25.46868-2.39401-36.41513-7.76058-3.84845-1.85665-13.4891-7.2847-13.4891-7.2847L0,157.09137c33.30575,23.51971,99.12273,31.26505,124.89115-5.78729,11.1857-16.06283,11.27037-43.63011-3.49229-57.23231-7.6776-7.57517-20.01078-13.82041-36.99789-18.73578Z" fill="#fff"/><path d="M790.68535,100.41078c-6.03368-6.47535-14.40579-11.92721-24.89335-16.21111,25.26179-12.91737,36.33783-38.58945,20.36312-62.57705C774.49925,5.64173,754.52217,.05704,733.73394,0c-18.14196,.00008-32.74624,4.13414-43.41054,12.28585-17.66816,12.18791-20.85941,40.543-9.6009,57.39671,4.20349,6.154,10.11753,11.36238,17.58962,15.48573-9.73981,4.8351-17.28531,10.84487-22.43529,17.87142-13.84974,18.56313-9.09803,47.77103,9.89505,60.83184,26.19382,19.30564,84.67616,19.39121,106.06347-10.39986,11.02055-14.21435,11.12344-40.5024-1.15-53.06091Zm-33.65784,37.34851c-15.65907,11.91712-44.70854,9.93059-53.76261-5.59011-3.59206-6.85544-.64515-15.47092,3.5988-21.28952,2.43563-3.33933,9.97612-9.79344,16.00635-12.94862,0,0,18.18836,3.25167,25.81338,6.87332,15.93227,6.69711,24.13542,20.93715,8.34408,32.95493Zm-15.17447-62.15551c-9.88199-2.06753-21.20362-4.81653-28.3667-12.54243-3.47429-3.74728-6.09855-8.60596-5.79795-13.75209,.42557-7.28551,5.26265-14.10738,12.06462-16.86065,6.62593-2.68201,14.37498-2.97072,21.36877-1.90201,6.7323,1.02875,13.93211,3.81417,17.1684,10.31993,3.67903,7.3958,1.50335,16.87125-3.19842,23.06131-3.42395,4.50777-8.37242,8.53049-13.23872,11.67593Z" fill="#fff"/><path d="M271.61876,85.32183c-4.3962-13.17278-13.2769-24.88125-24.79451-31.83088-19.99428-12.58345-54.21966-9.87573-69.66625,7.97697v-16.2317h-33.28054V221.66h33.28054v-56.78304c7.39804,6.36148,24.17375,11.3245,38.62528,11.23085,4.13398,.14315,8.2412-.34718,12.07416-1.18135,39.86146-8.00521,56.09904-53.85977,43.76132-89.60462Zm-61.84781,62.08038c-18.01158,0-32.61295-16.39306-32.61295-36.61514s14.60138-36.61514,32.61295-36.61514c18.01291,0,32.61429,16.39306,32.61429,36.61514s-14.60138,36.61514-32.61429,36.61514Z" fill="#fff"/><path d="M656.8826,119.17571c.66224-18.40256-4.1206-41.92185-18.56143-55.89134-25.26945-24.71067-69.33179-22.81423-94.82734,.55923-21.77229,19.35513-25.40859,57.0553-10.68012,81.1452,12.83808,21.10374,35.80909,31.09371,61.29662,30.96928,15.98472,.57796,31.00217-2.88916,45.69051-9.80266,3.66172-1.92923,6.98763-4.17954,10.24665-6.53555l-14.80607-24.8458h0c-6.51001,5.59034-14.57194,8.47481-22.88673,10.16322-13.69163,2.78012-30.18206,2.69249-41.80403-6.11679-2.48975-1.88775-4.66511-4.16349-6.44045-6.73557-1.34856-1.95331-2.47236-4.07653-3.24297-6.3255-.17794-.5191-1.57466-6.72754-1.08099-6.72754l97.09634,.14382Zm-40.54243-31.35192c1.53586,2.00682,2.91385,4.28791,4.14067,6.47535,.887,1.58004,1.57198,3.63235,1.57198,3.63235-.01472-.00134-62.26656,0-62.26656,0,6.83378-25.41841,42.1104-29.69963,56.55391-10.1077Z" fill="#fff"/><path d="M483.13772,146.27851c-20.22305,0-36.74994-15.26936-36.74994-35.49144s16.39277-36.61514,36.61582-36.61514c11.36242,0,22.69048,4.20394,29.97645,12.8306l14.33907-25.53461c-33.66986-27.98715-92.11048-18.61915-109.56819,23.34752-18.27915,44.38489,12.86618,91.89708,61.58425,91.14252,16.8249,.10302,35.0532-6.22516,48.28595-16.33821l-15.12917-25.2226c-8.71915,8.97013-18.28616,11.88136-29.35426,11.88136Z" fill="#fff"/><path d="M400.82069,98.25127c-3.27909-26.09806-16.95601-44.87857-39.98856-50.84686-7.85322-2.10583-17.47376-2.49849-26.42536-1.3914-13.96777,1.72748-27.79533,7.12489-39.92969,14.4926l15.8884,26.24121c.05485-.03478,.11238-.0689,.16723-.10435,6.31603-7.43394,15.55527-12.15064,25.88085-12.15064,8.30676,0,15.92452,3.039,21.87531,8.09619,2.26633,1.71784,4.58082,4.28858,6.05113,6.7155,2.19409,3.4718,3.36605,5.5201,4.53801,8.94775h-1.88504c-8.969-.3619-17.66641-.52913-26.02534,0-14.06356,.88969-27.1652,3.75543-38.97179,11.01277-.01338,.00803-.02676,.01472-.04014,.02341-23.82724,14.8458-18.56411,52.90586,6.69731,62.85702,12.78323,5.44652,28.03882,5.4124,41.1351,1.27835,.03211-.00334,.06422-.00401,.09633-.00736,6.07387-1.88574,11.75575-4.86119,17.10852-8.21861v11.42216h34.50602V105.73404c-.12308-2.56338-.37192-5.04314-.67829-7.48277Zm-33.82773,28.21592v8.0895c-.76789,.46021-8.82502,4.88683-11.66702,6.10189-7.09342,3.03271-15.003,6.21039-22.86685,5.70616-9.09757-.58333-16.64216-9.02552-10.65762-17.74223,8.99308-11.76399,31.91325-9.38256,45.19149-8.3651v6.20978Z" fill="#fff"/></svg>`;

function Chip({ label, selected, onClick }) {
  return (
    <button onClick={onClick} style={{
      padding: "6px 14px", borderRadius: "6px",
      border: selected ? "1.5px solid #c8a2ff" : "1.5px solid rgba(255,255,255,0.08)",
      background: selected ? "rgba(200,162,255,0.18)" : "rgba(255,255,255,0.03)",
      color: selected ? "#d4b8ff" : "rgba(255,255,255,0.55)",
      fontSize: "13px", cursor: "pointer", transition: "all 0.2s",
      fontFamily: "monospace", whiteSpace: "nowrap",
    }}>
      {label}
    </button>
  );
}

function Section({ catKey, cat, value, onChange }) {
  const isText = cat.type === "text";
  return (
    <div style={{ marginBottom: "28px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
        <span style={{ fontSize: "16px" }}>{cat.icon}</span>
        <span style={{ fontSize: "12px", fontWeight: 600, color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: "0.1em", fontFamily: "monospace" }}>
          {cat.label}
        </span>
      </div>
      {isText ? (
        <textarea value={value || ""} onChange={e => onChange(catKey, e.target.value)} placeholder={cat.placeholder} rows={catKey === "subject" ? 3 : 2}
          style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.03)", border: "1.5px solid rgba(255,255,255,0.08)", borderRadius: "8px", padding: "12px 14px", color: "rgba(255,255,255,0.9)", fontSize: "14px", fontFamily: "monospace", resize: "vertical", outline: "none" }}
          onFocus={e => (e.target.style.borderColor = "rgba(200,162,255,0.4)")}
          onBlur={e => (e.target.style.borderColor = "rgba(255,255,255,0.08)")}
        />
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {cat.options.map(([ruLabel, enVal]) => {
            const selected = Array.isArray(value) && value.includes(enVal);
            return (
              <Chip key={enVal} label={ruLabel} selected={selected} onClick={() => {
                if (catKey === "aspect") { onChange(catKey, selected ? [] : [enVal]); }
                else { const arr = Array.isArray(value) ? [...value] : []; onChange(catKey, selected ? arr.filter(v => v !== enVal) : [...arr, enVal]); }
              }} />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [values, setValues] = useState({});
  const [copied, setCopied] = useState(false);

  const handleChange = useCallback((key, val) => setValues(prev => ({ ...prev, [key]: val })), []);

  const buildPrompt = () => {
    const parts = [];
    if (values.subject) parts.push(translate(values.subject.trim()));
    ["style", "camera", "lighting", "color", "composition", "mood", "detail"].forEach(k => {
      const v = values[k];
      const cat = CATEGORIES[k];
      if (Array.isArray(v) && v.length) parts.push(`${cat.labelEn}: ${v.join(", ")}`);
    });
    if (Array.isArray(values.aspect) && values.aspect.length) parts.push(`--ar ${values.aspect[0]}`);
    const main = parts.join(", ");
    const neg = values.negative ? values.negative.trim() : "";
    return { main, neg };
  };

  const { main, neg } = buildPrompt();
  const fullPrompt = neg ? `${main}\n\nNegative prompt: ${neg}` : main;

  const handleCopy = () => {
    try {
      const ta = document.createElement("textarea");
      ta.value = fullPrompt;
      ta.style.position = "fixed";
      ta.style.top = "-9999px";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      alert("Не удалось скопировать. Выделите текст вручную.");
    }
  };

  const filledCount = ORDER.filter(k => {
    const v = values[k];
    return typeof v === "string" ? v.trim().length > 0 : Array.isArray(v) && v.length > 0;
  }).length;

  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0f", color: "rgba(255,255,255,0.9)", fontFamily: "monospace", margin: 0, padding: 0 }}>

      {/* Header */}
      <div style={{
        padding: "20px 32px", borderBottom: "1px solid rgba(255,255,255,0.06)",
        background: "linear-gradient(180deg, rgba(200,162,255,0.04) 0%, transparent 100%)",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <div style={{ width: "110px", height: "30px" }} dangerouslySetInnerHTML={{ __html: LOGO_SVG }} />
          <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.1)" }} />
          <div>
            <div style={{ fontSize: "13px", fontWeight: 600, color: "rgba(255,255,255,0.8)", letterSpacing: "0.04em" }}>Prompt Constructor</div>
            <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.3)", marginTop: "2px" }}>Конструктор промтов для AI генерации</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "11px", color: "rgba(255,255,255,0.3)", padding: "4px 12px", background: "rgba(255,255,255,0.04)", borderRadius: "4px" }}>
            {filledCount} / {ORDER.length}
          </span>
          <button onClick={() => setValues({})} style={{ padding: "7px 16px", borderRadius: "6px", border: "1px solid rgba(255,255,255,0.1)", background: "transparent", color: "rgba(255,255,255,0.4)", fontSize: "12px", cursor: "pointer", fontFamily: "monospace" }}>
            Сбросить
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: "32px 32px 0" }}>
        {ORDER.map(key => (
          <Section key={key} catKey={key} cat={CATEGORIES[key]} value={values[key]} onChange={handleChange} />
        ))}
      </div>

      {/* Output */}
      <div style={{ position: "sticky", bottom: 0, background: "linear-gradient(180deg, transparent, #0a0a0f 25%)", padding: "48px 32px 32px" }}>
        <div style={{ background: "rgba(200,162,255,0.04)", border: "1.5px solid rgba(200,162,255,0.15)", borderRadius: "12px", padding: "18px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
            <span style={{ fontSize: "11px", fontWeight: 600, color: "#c8a2ff", textTransform: "uppercase", letterSpacing: "0.12em" }}>
              Готовый промт (English)
            </span>
            <button onClick={handleCopy} style={{
              padding: "7px 18px", borderRadius: "6px", border: "none",
              background: copied ? "rgba(100,220,100,0.15)" : "linear-gradient(135deg, #8b5cf6, #6d28d9)",
              color: copied ? "#6ddc6d" : "#fff", fontSize: "12px", fontWeight: 600,
              cursor: "pointer", fontFamily: "monospace", transition: "all 0.2s",
            }}>
              {copied ? "✓ Скопировано" : "Копировать"}
            </button>
          </div>
          <div style={{ fontSize: "13px", lineHeight: 1.8, color: main ? "rgba(255,255,255,0.85)" : "rgba(255,255,255,0.2)", fontFamily: "monospace", wordBreak: "break-word", whiteSpace: "pre-wrap", maxHeight: "180px", overflowY: "auto" }}>
            {fullPrompt || "Выберите параметры выше чтобы собрать промт..."}
          </div>
        </div>
      </div>
    </div>
  );
}
